import { render, staticRenderFns } from "./ContentPage.vue?vue&type=template&id=0a0862a5"
import script from "./ContentPage.vue?vue&type=script&lang=js"
export * from "./ContentPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BreadcrumbNavigation: require('/vercel/path0/components/shared/BreadcrumbNavigation.vue').default,ContainerContent: require('/vercel/path0/components/shared/ContainerContent.vue').default,ComponentLoader: require('/vercel/path0/components/ComponentLoader.vue').default})
